/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_NameInputs */

const en_origin_name = /** @type {(inputs: Origin_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin name`)
};

const es_origin_name = /** @type {(inputs: Origin_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del origen`)
};

/**
* | output |
* | --- |
* | "Origin name" |
*
* @param {Origin_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const origin_name = /** @type {((inputs?: Origin_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_origin_name(inputs)
	return es_origin_name(inputs)
});